import { Controller } from "@hotwired/stimulus"

// Signature chain panel on the finance document pages: resend the current
// signer's email.
export default class extends Controller {
  static values = { resendUrl: String }

  async resend(e) {
    const btn = e.currentTarget
    btn.disabled = true
    try {
      const resp = await fetch(this.resendUrlValue, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
          "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]')?.content
        }
      })
      const data = await resp.json()
      if (!resp.ok) throw new Error(data.error || "Could not resend")
      this._showToast(`Reminder sent to ${data.email}`)
    } catch (err) {
      this._showToast(err.message, "alert")
    } finally {
      btn.disabled = false
    }
  }

  _showToast(message, type = "notice") {
    const div = document.createElement("div")
    div.className = type === "alert" ? "flash-toast-alert" : "flash-toast-notice"
    div.setAttribute("data-controller", "flash")
    div.setAttribute("data-flash-dismiss-after-value", "5000")
    div.textContent = message
    document.body.prepend(div)
  }
}
